module.exports = __webpack_public_path__ + "static/max-d2ca41dcda9730e984070d1db5a534d0.jpg";